module.exports = __webpack_public_path__ + "static/media/corporate-services-img69.fe4b5fc1.jpg";